import React, { FC } from 'react';

import { APIS } from '../../../lib/constants/apis';
import ZuwendungsantragRightSidebar from './right-side-bar/ZuwendungsantragRightSidebar';
import MittelabrufSidebar from './right-side-bar/MittelabrufSidebar';
import VerwendungsnachweisRightSidebar from './right-side-bar/VerwendungsnachweisRightSidebar';

const AntragRightSideBar: FC<{ api: string }> = ({ api }) => {
	const RenderSideBar = () => {
		if (api === APIS.Zuwendungsantrag) {
			return <ZuwendungsantragRightSidebar />;
		}
		if (api === APIS.Mittelabruf) {
			return <MittelabrufSidebar />;
		}
		if (api === APIS.Verwendungsnachweis) {
			return <VerwendungsnachweisRightSidebar />;
		}
		return <></>;
	};

	return <RenderSideBar />;
};
export default AntragRightSideBar;
